import { memo } from 'react';

import { useTranslations } from 'next-intl';

/**
 * What the visitor sees while a tap or send made before the chat was ready is waiting: "Still
 * connecting..." with Cancel, or the couldn't-connect message with Try again. Both rows are
 * server-rendered hidden and shown by CSS from the state lib/early-input/bootstrap.ts sets on
 * <html>, because they have to work before React has hydrated anything. That script also reads the
 * screen-reader texts from the data attributes, so they come in the page's own language.
 */
export const EarlyLoadStatus = memo(function EarlyLoadStatus() {
  const t = useTranslations();

  return (
    <div
      data-early-status=""
      data-text-sending={t('earlyInput.sending')}
      data-text-sending-question={t('earlyInput.sendingQuestion', { question: '{question}' })}
      data-text-slow={t('earlyInput.stillConnecting')}
      data-text-canceled={t('earlyInput.sendingCanceled')}
      data-text-failed={t('earlyInput.couldNotConnect')}
      // `contents`: the composer column spaces its children with a gap, and this wrapper is empty
      // almost always; only a row it shows should take a place in that column.
      className="aui-early-load-status contents text-center text-xs text-muted-foreground"
    >
      <div data-early-slow="" className="items-center justify-center gap-2 py-1">
        <span>{t('earlyInput.stillConnecting')}</span>
        <button
          type="button"
          data-early-cancel=""
          className="font-medium text-foreground underline"
        >
          {t('thread.buttons.cancel')}
        </button>
      </div>
      <div
        data-early-failed=""
        className="flex-wrap items-center justify-center gap-x-2 gap-y-1 py-1 text-destructive"
      >
        <span>{t('earlyInput.couldNotConnect')}</span>
        <button type="button" data-early-retry="" className="font-medium underline">
          {t('thread.buttons.retry')}
        </button>
      </div>
      <noscript>
        <p className="py-1">{t('earlyInput.stillLoading')}</p>
      </noscript>
    </div>
  );
});
